import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  OnInit,
  output,
} from '@angular/core';
import { MatChipsModule } from '@angular/material/chips';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TimelineItemType } from '@fdm/api-client';
import { TimelineRecord } from '../../models';
import { MatIconButton } from '@angular/material/button';
import { ApprovalStatePipe } from '../../../../../reports/pipes';
import { utcToLocal } from '@fdm/utils';
import { FormatTextPipe } from '../../../../pipes';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-timeline-record',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatIconModule,
    MatIconButton,
    MatChipsModule,
    ApprovalStatePipe,
    FormatTextPipe,
],
  templateUrl: './timeline-record.component.html',
  styleUrl: './timeline-record.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimelineRecordComponent implements OnInit {
  public download = output<string | undefined>();

  public delete = output<void>();
  
  public edit = output<void>();

  public timeline = input.required<TimelineRecord>();
  
  public haveAccess = input<boolean>(true);

  public readonly TimelineItemType = TimelineItemType;

  public readonly EMAIL = 'Email from: noreply-tco-fdm@tengizchevroil.com';

  created = computed(() => {
    const initDate = this.timeline().created;

    return initDate ? utcToLocal(initDate)?.toDate() : null;
  })

  canEditOrDelete = computed(() => {
    const title = this.timeline().title;
    const hasAccess = this.haveAccess();
    
    // Hide edit/delete buttons if title contains "Action Item Completed"
    if (title && title.includes('Action Item Completed')) {
      return false;
    }
    
    return hasAccess;
  });

  form = new FormGroup({
    text: new FormControl<string | null>(null)
  });

  isEditing = false;

  ngOnInit(): void {
    const data = this.timeline();
    this.form.patchValue({
      ...data,
      text: data.previewText
    });    
  }

  editNote() {
    this.isEditing = true;
  }

  public isExpanded = false;
}
